
import ChannelTable from '/src/features/plugins/channels/components/ChannelTable/ChannelTable';

function ChannelList() {

    return <ChannelTable/>
}

export default ChannelList;